import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addExportConfig, updateExportConfig, destroyExportConfig } from 'services/exports/duck';


class ExportableProps extends React.PureComponent {
    constructor(props) {
        super(props);

        if (!props.type) {
            throw new Error('ExportableProps: Missing required type prop');
        }

        if (!props.exportName) {
            console.warn('ExportableProps: Missing exportName from callout with change'); // eslint-disable-line no-console
        }
    }

    componentDidMount() {
        if (this.props.exportName) {
            const config = {
                ...this.props
            };

            this.props.addExportConfig(config);
        }
    }

    componentDidUpdate() {
        if (this.props.exportName) {
            this.props.updateExportConfig({
                ...this.props
            });
        }
    }

    componentWillUnmount() {
        if (this.props.exportName) {
            this.props.destroyExportConfig({
                exportName: this.props.exportName
            });
        }
    }

    render() {
        return null;
    }
}

ExportableProps.propTypes = {
    type: PropTypes.string.isRequired,
    exportName: PropTypes.string.isRequired
};

const ExportablePropsConnected = connect(null, {
    addExportConfig,
    updateExportConfig,
    destroyExportConfig
})(ExportableProps);

export default ExportablePropsConnected;

export const ExportableChannelSummaryCallout = props => (
    <ExportablePropsConnected type="channel-summary-callout" {...props} />
);



// WEBPACK FOOTER //
// ./src/containers/callouts/Exportable.js